import { normalizePercent } from "@/pages/Planning/utils/normalizePercent";

export function parseComplianceFilterValue(value) {
	if (value === undefined || value === null || value === "") {
		return null;
	}
	const parsedValue = Number(String(value).replace(",", "."));
	if (Number.isNaN(parsedValue)) {
		return null;
	}
	return parsedValue;
}

export function validateComplianceRange(complianceFrom, complianceTo) {
	const fromValue = parseComplianceFilterValue(complianceFrom);
	const toValue = parseComplianceFilterValue(complianceTo);

	if (fromValue !== null && fromValue < 0) {
		return "El % Cumplimiento Desde no puede ser negativo.";
	}
	if (toValue !== null && toValue < 0) {
		return "El % Cumplimiento Hasta no puede ser negativo.";
	}
	if (fromValue !== null && toValue !== null && fromValue > toValue) {
		return "El % Cumplimiento Desde no puede ser mayor que Hasta.";
	}

	return null;
}

export function matchesComplianceRange(percentUsedValue, complianceFrom, complianceTo) {
	const percentUsed = normalizePercent(percentUsedValue);
	const fromValue = parseComplianceFilterValue(complianceFrom);
	const toValue = parseComplianceFilterValue(complianceTo);

	if (fromValue === null && toValue === null) {
		return true;
	}
	if (fromValue !== null && percentUsed < fromValue) {
		return false;
	}
	if (toValue !== null && percentUsed > toValue) {
		return false;
	}
	return true;
}
